import h from 'hyperscript';
import { t } from 'javascripts/utils/withTranslation';

function getSearchQuery($form, $items) {
  if (!$items || !$form || !$form.action) {
    console.error('Solr submit - form or items not found');
    return '/';
  }

  let filterIndex = 0;

  const query = Array.from($items)
    .map(($item) => {
      const $input = $item;
      const name = $input.getAttribute('name');
      const { value } = $input;
      const isMultiselect =
        $input?.tagName?.toLowerCase() === 'select' && $input.multiple;

      if (!name || (!value && value !== '')) {
        return null;
      }

      if (name === 'tx_solr[q]') {
        const emptyValue = value === '' ? '*' : value;
        return `${name}=${emptyValue}`;
      }

      if (name !== 'tx_solr[filter]') {
        return `${name}=${value}`;
      }

      if (isMultiselect) {
        const multiString = [];
        Array.from($input.options).forEach(($o) => {
          const $option = $o;
          const adjustName = `tx_solr[filter][${filterIndex}]`;
          const adjustValue = `type:${$option.value}`;
          if ($option.selected) {
            multiString.push(`${adjustName}=${adjustValue}`);
            filterIndex += 1;
          }
          return null;
        });
        return multiString.join('&');
      }
      console.error('Solr submit - multiselect filter not found');
      return null;
    })
    .filter(Boolean)
    .join('&');

  return `${$form.action}?${query}`;
}

document.querySelectorAll('.js-solr-submit').forEach(($submit) => {
  const submit = (event) => {
    event.preventDefault();
    const $form = $submit.closest('form');
    const $items = $form.querySelectorAll('input, select');
    const submitQuery = getSearchQuery($form, $items);
    window.location.href = submitQuery;
  };

  $submit.addEventListener('click', submit);
});

// hook into html5 validation and collect all error messages
document.querySelectorAll('form.form').forEach(($form) => {
  const $submit = $form.querySelector(
    'input[type=submit], button:not([type=button])'
  );
  let $errorContainer = $form.querySelector('.form__errors');
  if (!$submit || $form.noValidate) {
    return;
  }

  if (!$errorContainer) {
    $errorContainer = h(
      '.announcement.announcement--warning.form__errors',
      { ariaLive: 'polite' },
      h('.text', [h('p', h('strong', t('Achtung:'))), h('ul')])
    );

    $form.prepend($errorContainer);
  }

  const inputHandler = (e) => {
    const $target = e.target;
    if ($target?.validity?.valid) {
      $target.removeAttribute('aria-invalid');
      $target.parentNode?.querySelector('.form-group__error')?.remove();
      $target.parentNode
        ?.querySelector('.label')
        ?.classList.remove('label--invalid');

      if ($target.tagName.toLowerCase() === 'select') {
        $target.removeEventListener('change', inputHandler);
      } else {
        $target.removeEventListener('input', inputHandler);
      }
    }
  };

  const showAllErrorMessages = ($formEl) => {
    $errorContainer = $errorContainer || $formEl.querySelector('.form__errors');
    if (!$errorContainer || !$errorContainer.querySelector('ul')) {
      console.warn(
        'No error container or the correct markup for it found in form'
      );
      return;
    }
    $errorContainer.querySelector('ul').innerHTML = '';
    $errorContainer.classList.remove('form__errors--active');
    $formEl.querySelectorAll('*[aria-invalid="true"]').forEach(($el) => {
      $el.removeAttribute('aria-invalid');
    });
    $formEl.querySelectorAll('.form-group__error').forEach(($el) => {
      $el.remove();
    });

    $formEl.querySelectorAll('.label--invalid').forEach(($el) => {
      $el.classList.remove('label--invalid');
    });

    const invalidFields = $form.querySelectorAll(':invalid');
    if (invalidFields.length === 0) {
      return;
    }
    $errorContainer.classList.add('form__errors--active');
    invalidFields.forEach(($field, i) => {
      const id =
        $field.id ||
        $field.name ||
        `field-${Math.random().toString(36).substr(2, 9)}`;
      const $label =
        $form.querySelector(`label[for="${$field.id}"]`) || $field.name;
      const labelText = $label?.textContent.replace(/\*/g, '');
      const message = $field.validationMessage || t('Fehler');
      const $errorItem = h('li', [`${labelText}: ${message}`]);
      const $errorMessage = h(
        'p.form-group__error',
        { id: `${id}-error` },
        message
      );

      $field.setAttribute('aria-invalid', 'true');
      $field.parentNode
        ?.querySelector('.label')
        ?.classList.add('label--invalid');
      const describeby = $field.getAttribute('aria-describedby') || '';
      $field.setAttribute('aria-describedby', `${describeby} ${id}-error`);

      // Remove any existing error message for this field
      const existingError = $field.parentNode.querySelector(`#${id}-error`);
      if (existingError) {
        existingError.remove();
      }
      $field.insertAdjacentElement('afterend', $errorMessage);
      $errorContainer.querySelector('ul').appendChild($errorItem);

      if ($field.tagName.toLowerCase() === 'select') {
        $field.addEventListener('change', inputHandler);
      } else {
        $field.addEventListener('input', inputHandler);
      }
    });
  };

  let errorShown = false;

  $form.addEventListener(
    'invalid',
    (e) => {
      if (!errorShown) {
        showAllErrorMessages($form);
        errorShown = true;
      }
    },
    true
  );

  $form.addEventListener('submit', () => {
    errorShown = false;
  });

  $submit.addEventListener('click', (e) => {
    errorShown = false;
    const $f = e.target.closest('form');
    const $err = $f.querySelector('.form__errors');
    $err?.classList.remove('form__errors--active');
    if ($err?.querySelector('ul')) {
      $err.querySelector('ul').innerHTML = '';
    }
  });
});
